import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { EdpTablePaginator } from "@edp-components/edp-table/edp-table.model";
import { OnboardingService } from "@edp-services/onboarding.service";
import { OnboardingTriggerUserEnum } from "@edp-enums/onboarding-trigger-user.enum";
import { EdpTableV2Service } from "./edp-table-v2.service";
import { TableData } from "./tableDataItem.model";

@Component({
    selector: "edp-table-v2",
    templateUrl: "./edp-table-v2.component.html",
    styleUrls: ["./edp-table-v2.component.scss"]
})
export class EdpTableV2Component implements OnInit {

    @Input() headerColumns: string[];
    @Input() set tableData(data: TableData[]) {
        this.fullTableData = data;
        this.filteredTableData = this.getTablePage(1, this.pageSize);
    }
    @Output() download = new EventEmitter();

    public pageSize = 10;
    public paginator: EdpTablePaginator = new EdpTablePaginator();
    fullTableData: TableData[] = [];
    public filteredTableData: TableData[] = [];
    public total: number;
    public page: number;


    constructor(
        public service: EdpTableV2Service,
        private readonly onboardingService: OnboardingService,
    ) { }


    ngOnInit() {
        this.initPagination(this.filteredTableData.length);
    }

    public changePage(page: number, pageSize: number) {
        this.page = page;
        this.filteredTableData = this.getTablePage(page, pageSize);
    }

    public initPagination(total: number) {
        this.page = 1;
        this.total = total;
    }

    public getTablePage(page: number, pageSize: number) {
        const initPosition = page === 1 ? 0 : (page - 1) * pageSize;
        const endPosition = page === 1 ? pageSize : page * pageSize;
        let finalTable: Array<any>;
        const filteredByType = [...this.fullTableData];
        finalTable = filteredByType;
        this.total = finalTable.length;
        return [...finalTable.slice(initPosition, endPosition)];
    }

    public titleCase(string) {
        return string[0].toUpperCase() + string.slice(1).toLowerCase();
    }

    public orderByDate(desc: boolean) {
        if (desc) {
            const arrayHolder = this.filteredTableData.sort((a, b) => new Date(b.col1.data).getTime() - new Date(a.col1.data).getTime());
            this.filteredTableData = arrayHolder;
        } else {
            const arrayHolder = this.filteredTableData.sort((a, b) => new Date(a.col1.data).getTime() - new Date(b.col1.data).getTime());
            this.filteredTableData = arrayHolder;
        }
    }

    public downloadItem(link: string) {
        this.onboardingService.registerUserAction(OnboardingTriggerUserEnum.INVOICE_DOWNLOAD_1M).subscribe();
        this.download.emit(link);
    }

}
